var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "0 0 2500 2500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripe-a",
    x1: "100%",
    x2: "0%",
    y1: "58.356%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2697D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#207BCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2285CE"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#stripe-a)",
    points: "0 0 2500 0 2500 2500 0 2500"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1364.14062,1083.98438 C1237.90039,1037.30469 1168.7207,1000.97656 1168.7207,943.916016 C1168.7207,895.478516 1208.49609,867.822266 1279.4043,867.822266 C1409.10156,867.822266 1542.25586,917.978516 1633.91602,962.929688 L1685.79102,643.007812 C1613.1543,608.417969 1464.43359,551.357422 1258.64258,551.357422 C1113.38867,551.357422 992.333984,589.394531 905.869141,660.302734 C815.927734,734.658203 769.248047,841.884766 769.248047,971.582031 C769.248047,1206.76758 912.783203,1307.07031 1146.24023,1391.80664 C1296.68945,1445.41992 1346.8457,1483.4668 1346.8457,1542.25586 C1346.8457,1599.32617 1298.4082,1632.17773 1210.22461,1632.17773 C1101.26953,1632.17773 921.435547,1578.57422 803.828125,1509.4043 L751.953125,1832.7832 C852.246094,1889.85352 1039.01367,1948.64258 1232.71484,1948.64258 C1386.62109,1948.64258 1514.58984,1912.33398 1601.05469,1843.16406 C1697.89062,1767.07031 1748.04687,1654.66797 1748.04687,1509.4043 C1748.04687,1269.02344 1601.05469,1168.7207 1364.13086,1083.99414 L1364.14062,1083.98438 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.0118960c59a7142dc8d045d978575d28.svg";
export { ForwardRef as ReactComponent };